import { render } from "./newShedForth.vue?vue&type=template&id=2e9c28da&scoped=true"
import script from "./newShedForth.vue?vue&type=script&lang=js"
export * from "./newShedForth.vue?vue&type=script&lang=js"

import "./newShedForth.vue?vue&type=style&index=0&id=2e9c28da&lang=scss&scoped=true"
import "./newShedForth.vue?vue&type=style&index=1&id=2e9c28da&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9c28da"]])

export default __exports__